import { render, staticRenderFns } from "./orderTaber.vue?vue&type=template&id=5ec62490&scoped=true&"
import script from "./orderTaber.vue?vue&type=script&lang=js&"
export * from "./orderTaber.vue?vue&type=script&lang=js&"
import style0 from "./orderTaber.vue?vue&type=style&index=0&id=5ec62490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec62490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec62490')) {
      api.createRecord('5ec62490', component.options)
    } else {
      api.reload('5ec62490', component.options)
    }
    module.hot.accept("./orderTaber.vue?vue&type=template&id=5ec62490&scoped=true&", function () {
      api.rerender('5ec62490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/sendNewDetail/comp/orderTaber.vue"
export default component.exports